import moment, { MomentInput } from 'moment-timezone';

import { FormValues } from '../../../../../../components/TyAdvancedSearch/Libs/transform';

const apiTransformationsMpsv = {
  company: (companies: FormValues[]) => {
    if (companies.length === 0) return undefined;
    const $query = { employer_id: { $in: companies.map((c) => c.value) } };

    return $query;
  },

  tymber: (tymbers: FormValues[]) => {
    if (tymbers.length === 0) return undefined;
    const $query = {
      employee_id: { $in: tymbers.map((t) => t.value) },
    };
    return $query;
  },

  dateFormatFrom: (date: MomentInput) => ({
    'contracts.created_at': { $gte: moment(date).tz('Europe/Prague').startOf('day').toISOString() },
  }),

  dateFormatTo: (date: MomentInput) => ({ 'contracts.created_at': { $lte: moment(date).tz('Europe/Prague').endOf('day').toISOString() } }),
  documentType: (documentType: FormValues) => ({ 'documentType.type': documentType.value }),
  state: (state: FormValues) => ({ state: state.value }),
};

export default apiTransformationsMpsv;
